import {
  GET_SERVICE_TYPE_FAIL,
  GET_SERVICE_TYPE_SUCCESS,
  GET_SERVICE_TYPES_FAIL,
  GET_SERVICE_TYPES_SUCCESS,
  ADD_SERVICE_TYPE_SUCCESS,
  ADD_SERVICE_TYPE_FAIL,
  UPDATE_SERVICE_TYPE_SUCCESS,
  UPDATE_SERVICE_TYPE_FAIL,
  DELETE_SERVICE_TYPE_SUCCESS,
  DELETE_SERVICE_TYPE_FAIL,  
  SET_STATE_SERVICE_TYPE
} from "./actionTypes";

const INIT_STATE = {
  serviceTypes: [],
  serviceType: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const serviceTypes = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SERVICE_TYPES_SUCCESS:
      return {
        ...state,
        serviceTypes: action.payload.serviceTypes,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_SERVICE_TYPE:
      return { ...state, loading: action.payload }

    case GET_SERVICE_TYPES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        serviceTypes: [...state.serviceTypes, action.payload],
      };

    case ADD_SERVICE_TYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        serviceTypes: state.serviceTypes.map(serviceType =>
          serviceType.id.toString() === action.payload.id.toString()
            ? { ...action.payload, ...serviceType }
            : serviceType
        ),
      };

    case UPDATE_SERVICE_TYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        serviceTypes: state.serviceTypes.filter(
          serviceType => serviceType.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_SERVICE_TYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        serviceType: action.payload,
      };

    case GET_SERVICE_TYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default serviceTypes;
